export default __webpack_public_path__ + "static/media/Srt.43164bcb.png";